import { Component, ojs, app, state, v, payload } from "modular-openscriptjs";
import {
    cleanDispose,
    eParse,
    empty,
    inform,
    isMobile,
    updateStateValue,
} from "../../helpers";
import { dom, tool } from "../../fotastart";
import { STRINGS, uc, gc, dc, api } from "../../declarations";
import { $e } from "../../ojs.events";
import { routes } from "../../backendRoutes";
import SearchResultProductView from "../Views/SearchResultProductView";

const h = app("h");
const broker = app("broker");

ojs(SearchResultProductView);

export default class OrderRepeatForm extends Component {
    holder = null;
    status = state("loading"); // 'loading', 'success', 'reconfiguration_needed', 'error'
    reconfigProducts = state({});

    constructor() {
        super();
        this.status.listener(this);
        this.reconfigProducts.listener(this);
    }

    $$order = {
        needs: {
            repeatForm: (ed) => {
                this.showForm(ed);
            },
        },
    };

    showForm(ed) {
        if (this.holder) {
            cleanDispose(this.holder);
        }

        this.status.value = "loading";
        this.reconfigProducts.value = [];

        const formMarkup = () => this.renderForm();

        if (isMobile()) {
            this.holder = tool.offcanvas(
                h.OrderRepeatCanvas(formMarkup(), {
                    class: "p-0 rounded-top-5",
                    style: "height: auto; max-height: 90vh;",
                }),
            );
        } else {
            this.holder = tool.plainModal(h.OrderRepeatModal(formMarkup()));
        }

        this.holder.show();

        const { orderId } = eParse(ed).message;
        this.repeatOrder(orderId);
    }

    async repeatOrder(orderId) {
        let res = await api.post(`${routes.orders}/${orderId}/repeat`);

        if (!res) {
            this.status.value = "error";
            return;
        }

        broker.broadcast($e.order.repeated);
        broker.send($e.deliveryAddress.needs.allAddresses);

        if (res.data?.status === "reconfiguration_needed") {
            this.reconfigProducts.value = res.data.products || {};
            this.status.value = "reconfiguration_needed";
        } else {
            this.status.value = "success";
        }
    }

    closeForm() {
        if (this.holder) {
            this.holder.hide();
        }
    }

    goToCart() {
        this.closeForm();
        broker.broadcast($e.order.repeated);
        app("router").to("/cart");
    }

    renderForm() {
        return h.div(
            {
                class: "order-repeat-container d-flex flex-column gap-4 text-center py-3",
            },
            h.div(
                {
                    class: "d-flex justify-content-between align-items-center mb-4",
                },
                h.h4({ class: "fw-bold mb-0 text-primary" }, "Repeat An Order"),
                h.button({
                    type: "button",
                    class: "btn-close",
                    listeners: { click: () => this.closeForm() },
                }),
            ),
            v(this.status, (status) => {
                let statusVal = status.value;

                if (statusVal === "loading") {
                    return h.div(
                        {
                            class: "d-flex flex-column align-items-center justify-content-center py-5 gap-3",
                        },
                        h.div(
                            {
                                class: "spinner-border text-primary",
                                role: "status",
                                style: "width: 3rem; height: 3rem;",
                            },
                            h.span({ class: "visually-hidden" }, "Loading..."),
                        ),
                        h.p(
                            { class: "text-muted fs-5 mb-0 fw-semibold" },
                            "Adding your previous items to the cart...",
                        ),
                    );
                }

                if (statusVal === "success") {
                    return h.div(
                        {
                            class: "d-flex flex-column align-items-center justify-content-center py-5 gap-3",
                        },
                        h.div(
                            {
                                class: "rounded-circle bg-success bg-opacity-10 p-3 d-flex align-items-center justify-content-center",
                                style: "width: 80px; height: 80px;",
                            },
                            h.i({
                                class: "fas fa-check-circle text-success fa-3x",
                            }),
                        ),
                        h.h4({ class: "fw-bold text-dark mt-2" }, "All set!"),
                        h.p(
                            { class: "text-muted mb-4 px-3" },
                            "We have added the items to your cart.",
                        ),
                        h.button(
                            {
                                class: "btn btn-primary btn-lg rounded-pill w-100 fw-bold py-3",
                                listeners: { click: () => this.goToCart() },
                            },
                            "Take me to my cart",
                        ),
                    );
                }

                if (statusVal === "reconfiguration_needed") {
                    return h.div(
                        { class: "text-start d-flex flex-column gap-3" },
                        h.div(
                            { class: "text-center px-2 mb-2" },
                            h.h4(
                                { class: "fw-bold text-dark" },
                                "Reselect Options",
                            ),
                            h.p(
                                { class: "text-muted small" },
                                "Some items in the order was updated. You need to reselect options for the following items before they can be added to your cart.",
                            ),
                        ),
                        h.div(
                            {
                                class: "reconfig-list overflow-auto px-1",
                                style: "max-height: 400px;",
                            },
                            v(this.reconfigProducts, (products) => {
                                return h.div(
                                    each(products.value, (product, itemId) => {
                                        return h.SearchResultProductView(
                                            product,
                                            {
                                                class: "mb-3 cursor-pointer",
                                                listeners: {
                                                    click: () => {
                                                        broker.send(
                                                            $e.product.needs
                                                                .display,
                                                            payload({
                                                                product,
                                                            }),
                                                        );
                                                        updateStateValue(
                                                            this
                                                                .reconfigProducts,
                                                            (current) => {
                                                                delete current[
                                                                    itemId
                                                                ];
                                                                return current;
                                                            },
                                                        );
                                                    },
                                                },
                                            },
                                        );
                                    }),
                                );
                            }),
                        ),
                        h.button(
                            {
                                class: "btn btn-primary btn-lg rounded-pill w-100 fw-bold py-3 mt-3",
                                listeners: { click: () => this.goToCart() },
                            },
                            "All Done",
                        ),
                    );
                }

                return h.div(
                    {
                        class: "d-flex flex-column align-items-center justify-content-center py-5 gap-3",
                    },
                    h.i({
                        class: "fas fa-exclamation-circle text-danger fa-3x",
                    }),
                    h.h4(
                        { class: "fw-bold text-dark mt-2" },
                        "Something went wrong",
                    ),
                    h.p(
                        { class: "text-muted px-3" },
                        "Failed to copy items to your cart. Please try again.",
                    ),
                    h.button(
                        {
                            class: "btn btn-outline-secondary rounded-pill px-4 py-2",
                            listeners: { click: () => this.closeForm() },
                        },
                        "Close",
                    ),
                );
            }),
        );
    }
}

export function OrderRepeatCanvas(...args) {
    return h.$(h.div({ class: "offcanvas-body p-4" }, ...args));
}

export function OrderRepeatModal(...args) {
    return h.$(
        h.div(
            { class: "modal-content border-0 rounded-4 shadow-lg" },
            h.div({ class: "modal-body p-4" }, ...args),
        ),
    );
}

ojs(OrderRepeatForm, OrderRepeatCanvas, OrderRepeatModal);
